export const iconFontAwesomeEnergyFireFlameCurved = (
	<i className="fa-solid fa-fire-flame-curved"></i>
);
